module.exports = __webpack_public_path__ + "img/bnaner3-home-min.72c7125a.png";